// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__A9tKY","textarea":"Textarea_textarea__CrLGD","label":"Textarea_label__vmYla"};